import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Card, Col, Form, Row, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { BASE_URL } from "../../services/Api";
import { authHeader } from "../../services/auth-header";

const CreateBrand = () => {
  const navigate = useNavigate();
  const [brandname, setbrandname] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validateForm = () => {
    if (!brandname) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please enter a brand name.',
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsLoading(true);

    const brandData = {
      brandname: brandname,
    };

    try {
      await axios.post(BASE_URL + "brand/save", brandData, {
        headers: authHeader(),

      });
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Brand added successfully!',
      });
      navigate("/brandindex/1");
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response.data,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD BRAND</h6>
          <Link to="/brandindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md="6">
                <Form.Group controlId="formbrandname">
                  <Form.Label>Brand Name</Form.Label>
                  <Form.Control
                    placeholder="Enter brand name"
                    value={brandname}
                    onChange={(e) => setbrandname(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <button className="button-70" type="button" onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? <Spinner animation="border" size="sm" /> : 'SUBMIT'}
            </button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CreateBrand;